(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7478],{

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 18446:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),

/***/ 25208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _router = __webpack_require__(62887);
var _router1 = __webpack_require__(30165);
var _useIntersection = __webpack_require__(93927);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    // replace state instead of push if prop is present
    router[replace ? "replace" : "push"](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
    });
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function(props, forwardedRef) {
    var _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior;
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, restProps = _objectWithoutProperties(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter"
    ]);
    children = childrenProp;
    if (legacyBehavior && typeof children === "string") {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var router = (0, _router1).useRouter();
    var ref2 = _react.default.useMemo(function() {
        var ref = _slicedToArray((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref2.href, as = ref2.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref1[0], isVisible = ref1[1], resetVisible = ref1[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale1 = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _router).getDomainLocale(as, curLocale1, router && router.locales, router && router.domainLocales);
        childProps.href = localeDomain || (0, _router).addBasePath((0, _router).addLocale(as, curLocale1, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 5172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ preferencesForAddressContext; }
/* harmony export */ });
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment preferencesForAddressContext on Preference {\n    _id\n    deliveryType\n    tableName\n    storeId\n    store {\n      _id\n      minimumAnticipationDays\n      availableScheduleDaysOptions {\n        label\n        value\n      }\n      schedule {\n        itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n      }\n    }\n    placeId\n    address {\n      _id\n      address\n      addressSecondary\n      addressLine2\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var preferencesForAddressContext = (0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject());


/***/ }),

/***/ 91874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useSetDeliveryTypeInPreferences; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src286744445_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src286744445_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src286744445_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5528);
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16825);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3172);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32533);
/* harmony import */ var _fragments_preferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5172);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        mutation setDeliveryTypeInPreferences($websiteId: ID, $deliveryType: ID) {\n          setUserPreferences(websiteId: $websiteId, deliveryType: $deliveryType) {\n            _id\n            ...preferencesForAddressContext\n          }\n        }\n        ",
        "\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useSetDeliveryTypeInPreferences() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var mutate = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useMutate */ .Tu)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loading = ref[0], setLoading = ref[1];
    var showMessage = (0,_hooks_useMessage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("website", {
        keyPrefix: "delivery.edit"
    }).t;
    var setDeliveryTypeInPreferences = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src286744445_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(deliveryType) {
            var result;
            return _codebuild_output_src286744445_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setLoading(true);
                        _ctx.next = 3;
                        return mutate({
                            mutation: (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_4__/* .gql */ .Ps)(_templateObject(), _fragments_preferencesForAddressContext_main__WEBPACK_IMPORTED_MODULE_6__/* .preferencesForAddressContext */ .P),
                            variables: {
                                deliveryType: deliveryType,
                                websiteId: websiteId
                            }
                        }).finally(function() {
                            return setLoading(false);
                        });
                    case 3:
                        result = _ctx.sent;
                        return _ctx.abrupt("return", result);
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setDeliveryTypeInPreferences(deliveryType) {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        setDeliveryTypeInPreferences: setDeliveryTypeInPreferences,
        loading: loading
    };
};


/***/ }),

/***/ 18899:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SpinnerLoading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function SpinnerLoading(props) {
    var color = props.color || "gray";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(props.className, {
            "h-5 w-5": !props.size || props.size === "sm",
            "h-4 w-4": props.size === "xs",
            "h-6 w-6": props.size === "md",
            "h-8 w-8": props.size === "lg",
            "h-10 w-10": props.size === "xl",
            "animate-spin": true,
            "text-white": color === "white",
            "text-gray-500": color === "gray",
            "text-blue-500": color === "blue" || color === "primary",
            "text-green-500": color === "green",
            "text-red-500": color === "red",
            "text-yellow-500": color === "yellow",
            "text-black": color === "black"
        }),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    });
};


/***/ }),

/***/ 90052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ StartOrdering; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/ClientSuspense/index.tsx
var ClientSuspense = __webpack_require__(88385);
// EXTERNAL MODULE: ./src/components/DeliveryWizard/internals/hooks/useSetDeliveryTypeInPreferences.main.ts
var useSetDeliveryTypeInPreferences_main = __webpack_require__(91874);
// EXTERNAL MODULE: ./src/components/fields/DeliveryType/index.tsx
var DeliveryType = __webpack_require__(35438);
// EXTERNAL MODULE: ./src/components/Loading/index.tsx
var Loading = __webpack_require__(69528);
// EXTERNAL MODULE: ./src/components/SafeSuspense/index.tsx
var SafeSuspense = __webpack_require__(5822);
// EXTERNAL MODULE: ./src/components/SuspenseLoading/Loading.tsx
var SuspenseLoading_Loading = __webpack_require__(53762);
// EXTERNAL MODULE: ./src/helpers/events/index.ts
var events = __webpack_require__(52860);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./src/helpers/misc/sleep.ts
var sleep = __webpack_require__(77712);
// EXTERNAL MODULE: ./src/hooks/useResizedImageURL.ts
var useResizedImageURL = __webpack_require__(25447);
// EXTERNAL MODULE: ./src/hooks/useScreenSize.ts
var useScreenSize = __webpack_require__(69347);
// EXTERNAL MODULE: ./src/hooks/useShouldUseNewAddressesUI.ts
var useShouldUseNewAddressesUI = __webpack_require__(17664);
// EXTERNAL MODULE: ./src/hooks/useState.ts
var useState = __webpack_require__(48249);
// EXTERNAL MODULE: ./src/hooks/useWebsiteId.ts
var useWebsiteId = __webpack_require__(16825);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/Container/index.js
var Container = __webpack_require__(59848);
// EXTERNAL MODULE: ./node_modules/apollo-hooks/dist/apollo-hooks.es.js
var apollo_hooks_es = __webpack_require__(3172);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/data/fragments/preferences/updateAddressFragment.main.ts
var updateAddressFragment_main = __webpack_require__(14482);
// EXTERNAL MODULE: ./src/helpers/websites/withWebsiteId.tsx
var withWebsiteId = __webpack_require__(91015);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withGraphQL.js
var withGraphQL = __webpack_require__(70791);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/components/fields/Select/index.js
var Select = __webpack_require__(97338);
// EXTERNAL MODULE: ./node_modules/@packages/justo-parts/lib/decorators/withMessage.js
var withMessage = __webpack_require__(77543);
// EXTERNAL MODULE: ./node_modules/@packages/react-apollo-decorators/lib/withMutation.js
var withMutation = __webpack_require__(68688);
// EXTERNAL MODULE: ./src/page-components/Checkout/Checkout/Delivery/Address/Update/index.tsx + 7 modules
var Update = __webpack_require__(96082);
// EXTERNAL MODULE: ./src/page-components/Order/Options/UpdateBasicOptions/StoreMessage/index.tsx
var StoreMessage = __webpack_require__(13467);
// EXTERNAL MODULE: ./node_modules/autobind-decorator/lib/esm/index.js
var esm = __webpack_require__(88572);
// EXTERNAL MODULE: ./node_modules/simple-react-form/lib/index.js
var simple_react_form_lib = __webpack_require__(40191);
// EXTERNAL MODULE: ./src/components/componentTypes/StartOrdering/Options/UpdateBasicOptions/styles.module.css
var styles_module = __webpack_require__(47105);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/StartOrdering/Options/UpdateBasicOptions/index.tsx
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc1 = {};
    Object.keys(descriptor).forEach(function(key) {
        desc1[key] = descriptor[key];
    });
    desc1.enumerable = !!desc1.enumerable;
    desc1.configurable = !!desc1.configurable;
    if ("value" in desc1 || desc1.initializer) {
        desc1.writable = true;
    }
    desc1 = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator ? decorator(target, property, desc) || desc : desc;
    }, desc1);
    var hasAccessor = Object.prototype.hasOwnProperty.call(desc1, "get") || Object.prototype.hasOwnProperty.call(desc1, "set");
    if (context && desc1.initializer !== void 0 && !hasAccessor) {
        desc1.value = desc1.initializer ? desc1.initializer.call(context) : void 0;
        desc1.initializer = undefined;
    }
    if (hasAccessor) {
        delete desc1.writable;
        delete desc1.initializer;
        delete desc1.value;
    }
    if (desc1.initializer === void 0) {
        Object.defineProperty(target, property, desc1);
        desc1 = null;
    }
    return desc1;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation setPreferences($websiteId: ID, $storeId: ID, $placeId: ID, $deliveryType: ID) {\n    setUserPreferences(\n      websiteId: $websiteId\n      storeId: $storeId\n      placeId: $placeId\n      deliveryType: $deliveryType\n    ) {\n      _id\n      storeId\n      placeId\n      websiteId\n      deliveryType\n      deliverAt\n      time\n      channel\n      menuId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var _class, _dec, _dec1;
var _dec2 = (0,withMutation["default"])((0,lib["default"])(_templateObject()));
var UpdateBasicOptions = _class = _dec2(_class = (0,withMessage/* default */.Z)(((_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(UpdateBasicOptions, _Component);
    var _super = _createSuper(UpdateBasicOptions);
    function UpdateBasicOptions() {
        _classCallCheck(this, UpdateBasicOptions);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {
            loading: null
        };
        return _this;
    }
    var _proto = UpdateBasicOptions.prototype;
    _proto.onChange = function onChange(params) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        if (_this.props.preferences.websiteId) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", _this.props.router.replace({
                            pathname: "/login",
                            query: {
                                nextPathname: _this.props.router.pathname
                            }
                        }));
                    case 3:
                        _this.setState({
                            loading: true
                        });
                        _ctx.next = 6;
                        return _this.props.setPreferences(_objectSpread({}, _this.props.preferences, params), {
                            refetchQueries: [
                                "getMyOrderPreferences",
                                "getUserPreferences"
                            ]
                        });
                    case 6:
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        _this.props.showMessage(_ctx.t0);
                    case 11:
                        _ctx.prev = 11;
                        _this.setState({
                            loading: false
                        });
                        return _ctx.finish(11);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8,
                    11,
                    14
                ]
            ]);
        }))();
    };
    _proto.renderPlace = function renderPlace() {
        var deliveryType = this.props.preferences.deliveryType;
        if (deliveryType !== "delivery") return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Update/* default */.Z, {
            preferences: this.props.preferences,
            onChange: this.onChange,
            autoSave: true
        });
    };
    _proto.renderStore = function renderStore() {
        if (this.state.loading) return null;
        var _props = this.props, _stores = _props.stores, stores = _stores === void 0 ? {
            items: []
        } : _stores, _preferences = _props.preferences, preferences = _preferences === void 0 ? {} : _preferences;
        var deliveryType = preferences.deliveryType;
        if (deliveryType === "delivery" || !deliveryType) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreMessage/* default */.Z, {
                preferences: preferences
            });
        }
        var filteredStores = stores.items.filter(function(store) {
            if (!store.address || !store.address.placeId) {
                return false;
            }
            if (deliveryType === "go" && store.acceptGo) {
                return true;
            }
            if (deliveryType === "serve" && store.acceptServe) {
                return true;
            }
            return false;
        });
        if (filteredStores.length === 1) {
            if (!this.props.preferences) return;
            if (this.state.loading) return;
            if (this.props.preferences.storeId !== filteredStores[0].value) {
                var _this = this;
                setTimeout(function() {
                    return _this.onChange({
                        storeId: filteredStores[0].value
                    });
                }, 0);
            }
            return;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
            fieldName: "storeId",
            label: "Elige un local",
            placeholder: "Selecciona un local",
            type: Select/* default */.Z,
            options: filteredStores
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (styles_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(simple_react_form_lib.Form, {
                state: this.props.preferences,
                onChange: this.onChange,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(simple_react_form_lib.Field, {
                        fieldName: "deliveryType",
                        type: DeliveryType/* default */.Z,
                        light: !this.props.useBox
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: this.props.attentionClassName,
                        children: [
                            this.renderPlace(),
                            this.renderStore()
                        ]
                    })
                ]
            })
        });
    };
    return UpdateBasicOptions;
}(react.Component)) || _class, _dec = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:type", Function), _dec1 = typeof Reflect !== "undefined" && typeof Reflect.metadata === "function" && Reflect.metadata("design:paramtypes", [
    void 0
]), _applyDecoratedDescriptor(_class.prototype, "onChange", [
    esm["default"],
    _dec,
    _dec1
], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _class)) || _class) || _class;
/* harmony default export */ var Options_UpdateBasicOptions = ((0,next_router.withRouter)(UpdateBasicOptions));

// EXTERNAL MODULE: ./src/components/componentTypes/StartOrdering/Options/styles.module.css
var Options_styles_module = __webpack_require__(73827);
var Options_styles_module_default = /*#__PURE__*/__webpack_require__.n(Options_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/StartOrdering/Options/index.tsx
function Options_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function Options_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function Options_getPrototypeOf(o1) {
    Options_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return Options_getPrototypeOf(o1);
}
function Options_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Options_setPrototypeOf(subClass, superClass);
}
function Options_possibleConstructorReturn(self, call) {
    if (call && (Options_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return Options_assertThisInitialized(self);
}
function Options_setPrototypeOf(o2, p1) {
    Options_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return Options_setPrototypeOf(o2, p1);
}
function Options_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var Options_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function Options_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function Options_createSuper(Derived) {
    var hasNativeReflectConstruct = Options_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = Options_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = Options_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return Options_possibleConstructorReturn(this, result);
    };
}
function Options_templateObject() {
    var data = Options_taggedTemplateLiteral([
        "\n    query getUserPreferences($websiteId: ID) {\n      preferences: userPreferences(websiteId: $websiteId) {\n        _id\n        websiteId\n        storeId\n        placeId\n        deliveryType\n        paymentType\n        deliverAt\n        cashAmount\n        time\n        menuId\n        ...updateAddressFragment\n      }\n      stores(websiteId: $websiteId) {\n        items {\n          _id\n          label: name\n          value: _id\n          acceptServe\n          acceptGo\n          address {\n            placeId\n          }\n        }\n      }\n    }\n    ",
        "\n  "
    ]);
    Options_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Options_class;
var Options_dec = (0,withGraphQL["default"])((0,lib["default"])(Options_templateObject(), updateAddressFragment_main/* default */.Z), {
    loading: null
});
var Options = Options_class = (0,withWebsiteId/* default */.Z)(Options_class = Options_dec((Options_class = /*#__PURE__*/ function(_Component) {
    "use strict";
    Options_inherits(Options, _Component);
    var _super = Options_createSuper(Options);
    function Options() {
        Options_classCallCheck(this, Options);
        return _super.apply(this, arguments);
    }
    var _proto = Options.prototype;
    _proto.render = function render() {
        var _props = this.props, preferences = _props.preferences, stores = _props.stores, attentionClassName = _props.attentionClassName, useBox = _props.useBox;
        if (!preferences) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: useBox ? (Options_styles_module_default()).box : (Options_styles_module_default()).container,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Options_UpdateBasicOptions, {
                preferences: preferences,
                stores: stores,
                useBox: useBox,
                attentionClassName: attentionClassName
            })
        });
    };
    return Options;
}(react.Component)) || Options_class) || Options_class) || Options_class;


// EXTERNAL MODULE: ./src/components/componentTypes/StartOrdering/styles.module.css
var StartOrdering_styles_module = __webpack_require__(25547);
var StartOrdering_styles_module_default = /*#__PURE__*/__webpack_require__.n(StartOrdering_styles_module);
;// CONCATENATED MODULE: ./src/components/componentTypes/StartOrdering/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function StartOrdering_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function StartOrdering_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                StartOrdering_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                StartOrdering_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function StartOrdering_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function StartOrdering_templateObject() {
    var data = StartOrdering_taggedTemplateLiteral([
        "\n      query startOrderingGetDeliveryOptions($websiteId: ID) {\n        preferences: userPreferences(websiteId: $websiteId) {\n          _id\n          websiteId\n          placeId\n          deliveryType\n          storeId\n        }\n        website(websiteId: $websiteId) {\n          _id\n          deliveryTypes\n        }\n      }\n    "
    ]);
    StartOrdering_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
























var OptionsWrapper = function(param) {
    var _useBox = param.useBox, useBox = _useBox === void 0 ? false : _useBox;
    var websiteId = (0,useWebsiteId/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref = _slicedToArray((0,useState/* default */.Z)(), 2), attentionClassName = ref[0], setAttention = ref[1];
    var shouldUseNewAddressesUI = (0,useShouldUseNewAddressesUI/* default */.Z)();
    var setDeliveryTypeInPreferences = (0,useSetDeliveryTypeInPreferences_main/* default */.Z)().setDeliveryTypeInPreferences;
    var ref1 = _slicedToArray((0,useState/* default */.Z)(null), 2), selectedDeliveryType = ref1[0], setSelectedDeliveryType = ref1[1];
    var ref2 = (0,apollo_hooks_es/* useQuery_deprecated */.OT)((0,lib["default"])(StartOrdering_templateObject()), {
        websiteId: websiteId
    }, {
        fetchPolicy: "cache-first"
    }), preferences = ref2.preferences, website = ref2.website;
    var deliveryType = preferences.deliveryType, placeId = preferences.placeId, storeId = preferences.storeId;
    if (get_default()(website, "deliveryTypes", []).length === 0) return null;
    var order = function() {
        var _ref = StartOrdering_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(deliveryType === "go" && !storeId || deliveryType === "serve" && !storeId || deliveryType === "delivery" && !placeId)) {
                            _ctx.next = 6;
                            break;
                        }
                        setAttention("animated shake");
                        _ctx.next = 4;
                        return (0,sleep/* default */.Z)(1000);
                    case 4:
                        setAttention("animated");
                        return _ctx.abrupt("return");
                    case 6:
                        (0,events.sendEvent)(events.EVENTS.clicked.addressComponentOrder);
                        router.push("/pedir");
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function order() {
            return _ref.apply(this, arguments);
        };
    }();
    var button = deliveryType && (deliveryType === "serve" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/reservar",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (StartOrdering_styles_module_default()).button,
                    children: "S\xf3lo reservar una mesa"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (StartOrdering_styles_module_default()).button,
                onClick: order,
                children: "Pedir y reservar una mesa"
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        className: (StartOrdering_styles_module_default()).button,
        onClick: order,
        children: "Pedir"
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: shouldUseNewAddressesUI ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(SafeSuspense/* default */.Z, {
            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(SuspenseLoading_Loading/* default */.Z, {}),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-80",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliveryType/* default */.Z, {
                        omitOnChangeIfOnlyOneOption: true,
                        onChange: function(newSelectedDeliveryType) {
                            setSelectedDeliveryType(newSelectedDeliveryType);
                            setDeliveryTypeInPreferences(newSelectedDeliveryType).finally(function() {
                                return router.push("/pedir?addressModal=true");
                            });
                        },
                        value: selectedDeliveryType,
                        light: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (StartOrdering_styles_module_default()).button,
                    onClick: function() {
                        return router.push("/pedir");
                    },
                    children: "Pedir"
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Options, {
                    useBox: useBox,
                    attentionClassName: attentionClassName
                }),
                button
            ]
        })
    });
};
function StartOrdering(props) {
    var backgroundImage = props.backgroundImage, title = props.title, useBox = props.useBox, _ssrImage = props.ssrImage, ssrImage = _ssrImage === void 0 ? null : _ssrImage;
    var screenSize = (0,useScreenSize/* default */.Z)();
    var isMobile = screenSize === "mobile";
    var width = isMobile ? 800 : 1600;
    var height = isMobile ? 600 : 1200;
    var url = (0,useResizedImageURL/* default */.Z)({
        fileId: backgroundImage._id,
        width: width,
        height: height
    }, {
        partial: true
    });
    var backgroundURL = url ? url : ssrImage === null || ssrImage === void 0 ? void 0 : ssrImage.resizedURL;
    if ((0,isServerSide/* default */.Z)() && !(ssrImage === null || ssrImage === void 0 ? void 0 : ssrImage.resizedURL)) {
        console.warn("Could not fetch image for StartOrdering component while doing SSR. This should be fixed for an optimized experience.");
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {});
    }
    if (useBox) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (StartOrdering_styles_module_default()).containerBox,
            style: {
                backgroundImage: "url(".concat(backgroundURL, ")")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: (StartOrdering_styles_module_default()).boxContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StartOrdering_styles_module_default()).box,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (StartOrdering_styles_module_default()).titleBox,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsWrapper, {
                                useBox: true
                            })
                        })
                    ]
                })
            })
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (StartOrdering_styles_module_default()).container,
            style: {
                backgroundImage: "url(".concat(backgroundURL, ")")
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (StartOrdering_styles_module_default()).overlay
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (StartOrdering_styles_module_default()).content,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: (StartOrdering_styles_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ClientSuspense/* default */.Z, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionsWrapper, {})
                        })
                    ]
                })
            ]
        });
    }
};


/***/ }),

/***/ 34566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment timeFieldPreferences on Preference {\n    _id\n    deliveryType\n    timeLabel\n    time\n    itsStoreOpenAtTime\n    placeId\n    menuId\n    tableName\n    directions {\n      duration\n    }\n    website {\n      _id\n      name\n    }\n    store {\n      _id\n      name\n      schedule {\n        itsOpenNow: itsAvailableAt(websiteId: $websiteId)\n      }\n      schedulingOrdersDays\n      minimumAnticipationDays\n      currentPreparationDuration\n      currentDeliveryDuration\n      timeFormat\n      nextAvailableDate\n      availableScheduleDaysOptions {\n        label\n        value\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 14482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment updateAddressFragment on Preference {\n    _id\n    placeId\n    storeId\n    websiteId\n    preferredDeliveryStoreId\n    store {\n      _id\n      name\n      fullName\n      countryCode\n    }\n    address {\n      _id\n      placeId\n      address\n      addressLine2\n      addressSecondary\n      location\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 89894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((classnames__WEBPACK_IMPORTED_MODULE_0___default()));


/***/ }),

/***/ 6909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HasWebpSupport; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90257);

var result = null;
// https://stackoverflow.com/questions/5573096/detecting-webp-support
function HasWebpSupport() {
    if (result !== null) {
        return result;
    }
    if ((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)()) return true;
    result = false;
    var elem = document.createElement("canvas");
    if (elem.getContext && elem.getContext("2d")) {
        // was able or not to get WebP representation
        try {
            result = elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } catch (e) {
            result = false;
        }
    }
    // very old browser like IE 8, canvas not supported
    return result;
};


/***/ }),

/***/ 77712:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var sleep = function(time) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, time);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (sleep);


/***/ }),

/***/ 1626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useKeyboardEvent; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useKeyboardEvent(combination, callback) {
    var keysToMatch = combination.toLowerCase().split("+");
    var keys = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({}).current;
    var callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    callbackRef.current = callback;
    var checkEvent = function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysToMatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var keyToMatch = _step.value;
                if (!keys[keyToMatch]) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current();
    };
    var onKeyDown = function(event) {
        if (event && event.key) {
            var key = event.key.toLowerCase();
            keys[key] = true;
        }
    };
    var onKeyUp = function(event) {
        if (event && event.key) {
            checkEvent();
            var key = event.key.toLowerCase();
            delete keys[key];
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keyup", onKeyUp);
        document.addEventListener("keydown", onKeyDown);
        return function() {
            document.removeEventListener("keyup", onKeyUp);
            document.removeEventListener("keydown", onKeyDown);
        };
    });
};


/***/ }),

/***/ 53630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; },
/* harmony export */   "s": function() { return /* reexport safe */ react__WEBPACK_IMPORTED_MODULE_0__.useRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);




/***/ }),

/***/ 25447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useResizedImageURL; }
/* harmony export */ });
/* harmony import */ var _helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6909);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90257);
/* harmony import */ var apollo_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3172);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50456);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66678);
/* harmony import */ var lodash_clone__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_clone__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _useLocalStorageState__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54501);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getResizedImage(\n        $fileId: ID\n        $scale: Float\n        $width: Float\n        $height: Float\n        $resizeMode: ID\n        $background: String\n        $format: String\n      ) {\n        image(fileId: $fileId) {\n          _id\n          resizedURL(\n            scale: $scale\n            width: $width\n            height: $height\n            resizeMode: $resizeMode\n            background: $background\n            format: $format\n          )\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






function useResizedImageURL(opt) {
    var queryOpts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var options = lodash_clone__WEBPACK_IMPORTED_MODULE_1___default()(opt);
    if (options.format !== "jpeg" && (0,_helpers_misc_hasWebpSupport__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)()) {
        options.format = "webp";
    }
    var cacheKey = "resizedImage.".concat(JSON.stringify(options));
    var cachedResult = (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)() ? null : (0,_useLocalStorageState__WEBPACK_IMPORTED_MODULE_2__/* .localStorageGetItem */ .G)(cacheKey);
    var image = (0,apollo_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useApolloQuery */ .Zu)(_objectSpread({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__["default"])(_templateObject()),
        variables: options,
        omit: !!cachedResult || !options.fileId || (0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)()
    }, queryOpts)).image;
    if (!options.fileId) return null;
    if (cachedResult) return cachedResult;
    if (!image) return null;
    localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(cacheKey, image.resizedURL);
    return image.resizedURL;
};


/***/ }),

/***/ 69347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScreenSize; }
/* harmony export */ });
/* harmony import */ var _useWidth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9177);

function useScreenSize() {
    var width = (0,_useWidth__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();
    // Using Tailwind breakpoints and semantics
    if (width < 640) return "mobile";
    if (width < 768) return "sm";
    if (width < 1024) return "md";
    if (width < 1280) return "lg";
    if (width < 1536) return "xl";
    return "2xl";
};


/***/ }),

/***/ 17664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useShouldUseNewAddressesUI; }
/* harmony export */ });
function useShouldUseNewAddressesUI() {
    return true;
};


/***/ }),

/***/ 9177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* unused harmony exports DEFAULT_DESKTOP_WIDTH, DEFAULT_MOBILE_WIDTH */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90257);
/* harmony import */ var _providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95078);




var DEFAULT_DESKTOP_WIDTH = 1920;
var DEFAULT_MOBILE_WIDTH = 360;
function useWidth() {
    var ssrMobileOrDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_providers_MobileOrDesktopContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ssrWidth = ssrMobileOrDesktop === "mobile" ? DEFAULT_MOBILE_WIDTH : DEFAULT_DESKTOP_WIDTH;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_helpers_misc_isServerSide__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)() ? ssrWidth : window.innerWidth), width = ref[0], setWidth = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = function handler() {
            setWidth(window.innerWidth);
        };
        window.addEventListener("resize", handler);
        return function() {
            window.removeEventListener("resize", handler);
        };
    }, []);
    return width !== null && width !== void 0 ? width : ssrWidth;
};


/***/ }),

/***/ 95078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

/* harmony default export */ __webpack_exports__["Z"] = (react__WEBPACK_IMPORTED_MODULE_0__.createContext("desktop"));


/***/ }),

/***/ 47105:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3O4csE5N1a9Fgx45gzz5Jv","label":"HIYKvE68DxiQ3bFtAhOgx"};

/***/ }),

/***/ 73827:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2xOS0G-prTmDR4zxeHqrkS"};

/***/ }),

/***/ 25547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1AhtSgNBQZdrJ7FDzXt0F3","containerBox":"X6etWOA8Ui_qiKzF0xj5V","boxContainer":"_3uHDdvVcU9me6l9XXJ0PTh","title":"_26TWwdnPJAhejabFkROEPz appTitle","box":"_2qY3AMe0QjtXKHHNtnbMg6 shadow","titleBox":"_2NTJI2RgUSvRMsBAFD3iEm appTitle","content":"_2O5eNsUUz_CpxAOuro8Unp","label":"_1oKMjRN7GFgzOY95HzOYdk","form":"_2o94k5QKCSjvKIWP6vaTEH","overlay":"_3qNVOPc6FYocN0DfyuZV__","button":"_1OglEPY-_upwpkdnFUquCU buttonShadow"};

/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(25208)


/***/ })

}]);